import Page from '../..';
import Collapse from '../../../Collapse';
import useStore from '../../../Hooks/useStore';
import Tabs from '../../../Tabs';
import * as S from './Styles';

export function PageBannerConfigurations() {
  const [getters] = useStore();
  const {
    banner: { getAllLayouts },
  } = getters;

  const layouts = getAllLayouts();
  const layoutTitles = [...new Set(layouts.map(({ name }) => name))];

  const Layouts = () => {
    return (
      <S.TabContainer>
        {layoutTitles.map((title) => (
          <Collapse key={title} title={title}>
            <div>{title}</div>
          </Collapse>
        ))}
      </S.TabContainer>
    );
  };

  return (
    <Page className="page-banner">
      <S.PageContainer>
        <Tabs
          items={[
            {
              label: 'LAYOUTS',
              children: <Layouts />,
            },
            {
              label: 'FONTES',
              children: <></>,
            },
          ]}
        ></Tabs>
      </S.PageContainer>
    </Page>
  );
}
